interface ChartTooltipProps {
  active?: boolean;
  label?: string;
  payload?: { dataKey?: string; name?: string; value?: number; color?: string }[];
}

export function ChartTooltip({ active, payload, label }: ChartTooltipProps) {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div className="rounded-lg border border-slate-700 bg-slate-800 px-3 py-2 text-xs shadow-lg">
      <p className="mb-1 font-medium text-slate-300">{label}</p>
      {payload.map((entry) => (
        <p key={entry.dataKey} style={{ color: entry.color }}>
          {entry.name}: {(entry.value ?? 0).toLocaleString('de-DE')}
        </p>
      ))}
    </div>
  );
}

export const chartColors = {
  visitors: '#6366f1',
  sessions: '#38bdf8',
  conversions: '#34d399',
  pageViews: '#a78bfa',
  previous: '#64748b',
};
